import { defineStore } from "pinia";

export const useDefineRuleStore = defineStore("define-rule-store", {
    state: () => {
        return {
            selectedRuleValid: false,
        };
    },
});
